import useAccessControls from 'modules/access-controls/atoms/use-access-controls';
import useCreateCategory from 'modules/categories/hooks/use-create-category';
import {CategoryProps, translatedCategoryProps} from 'modules/categories/types';
import useCompaniesSelectData from 'modules/companies/hooks/use-companies-select-data';
import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

const CreateCategory: React.FC = () => {
  const {getInput, getSwitch, getSelect} = useFormInputs<CategoryProps>();
  const {data, isLoading} = useCompaniesSelectData();
  const {companyId} = useAccessControls();

  const handleSubmit = (data: CategoryProps) => {
    if (companyId) data.companyId = companyId;

    return data;
  };

  return (
    <Creation<CategoryProps>
      {...{handleSubmit}}
      titleBar={{title: 'Cadastrar categoria'}}
      defaultValues={{active: true}}
      onSubmit={useCreateCategory}
      inputs={[
        getInput({
          name: 'name',
        }),
        getSwitch({
          name: 'active',
        }),
        getSelect({
          name: 'companyId',
          data,
          isLoading,
          hidden: () => !!companyId,
        }),
      ]}
      translationKey={translatedCategoryProps}
    />
  );
};

export default CreateCategory;
